// extracted by mini-css-extract-plugin
export default {"smallImageGroup":"Form_smallImageGroup__Z7N+C","smallImage":"Form_smallImage__pR5qM","text":"Form_text__qllvH"};